
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/caterers/[city]/[caterer]",
      function () {
        return require("private-next-pages/caterers/[city]/[caterer].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/caterers/[city]/[caterer]"])
      });
    }
  